import { useNavigate } from 'react-router';

import { useUser } from '@/components/auth-provider';

/** Signs the user out and returns them to the login screen. */
export function useLogout() {
  const { logOut } = useUser();
  const navigate = useNavigate();

  return async function handleLogout() {
    await logOut();
    void navigate('/');
  };
}
